import {justflyLayout as tokensLayout} from '@vio/atlas-tokens'

export const {layout} = tokensLayout
